import moment from 'moment-timezone'
import SeriesScatter = echarts.EChartOption.SeriesScatter
import SeriesCustom = echarts.EChartOption.SeriesCustom
import SeriesBar = echarts.EChartOption.SeriesBar
import { GenericReading } from '@/jsonapi/SiteReadings'
import { GlucometerReadingCounts } from '@/jsonapi/SiteStats'

const GRID = [
  { x: '5%', y: '10%', width: '90%', height: '81.2%' },
  { x: '5%', y: '0%', width: '90%', height: '100%' },
]

export function buildSiteReadingTimelineChartOptions(options: {
  readingsPerMonth: Map<string, GlucometerReadingCounts>
  colors: any
  chartWidth: number
}): echarts.EChartOption<SeriesBar | SeriesCustom | SeriesScatter> {
  let { readingsPerMonth, colors, chartWidth } = options
  // let maxY = 400
  // let timestamps = []
  //
  // // let groupedByMonth = {}
  let data = []

  let valuesByMonthTs = {}
  Object.keys(readingsPerMonth).forEach(monthStr => {
    let monthTs = moment(monthStr + '-01', 'YYYYMM-DD').valueOf()
    valuesByMonthTs[monthTs] = readingsPerMonth[monthStr].totalCount
  })
  let lastTimestamp = moment()
    .startOf('day')
    .valueOf()
  let xLabels = Object.keys(readingsPerMonth).map(monthStr => moment(monthStr + '-01', 'YYYYMM-DD').format('MMM'))

  let sortedMonthTimestamps = Object.keys(readingsPerMonth)
    .map(monthStr => moment(monthStr + '-01', 'YYYYMM-DD').valueOf())
    .sort()

  let lastMonthTimestamp = Object.values(sortedMonthTimestamps)
    .sort()
    .pop()

  let lastMonthStr = moment(lastMonthTimestamp).format('YYYYMM')
  let totalLastMonth = readingsPerMonth[lastMonthStr].totalCount

  // -1 because readings from today aren't aggregated yet. min(1) so we don't divide by 0
  let days = Math.max(1, moment().diff(moment(lastMonthTimestamp), 'days') - 1)
  let readingsPerDay = totalLastMonth / days
  let readingsPerDayRounded = Math.round(readingsPerDay * 10) / 10

  // set the last month to estimate based on usage per day
  let lastMonthEstCount = Math.floor(readingsPerDay * 30)
  valuesByMonthTs[lastMonthTimestamp] = lastMonthEstCount

  function getTooltip(monthTS: number) {
    // let monthStr = moment(parseInt(monthTS)).format('YYYYMM')
    let MMM = moment(monthTS).format('MMM')
    let YM = moment(monthTS).format('YYYYMM')

    if (monthTS != lastMonthTimestamp) {
      return `${MMM}: ${readingsPerMonth[YM].totalCount} readings`
    } else {
      console.log(`lastMonthStart: ${lastMonthTimestamp}, lastReadingTimestamp: ${lastTimestamp}`)
      return `${MMM}: ${lastMonthEstCount} readings (estimated from ${readingsPerDayRounded} per day)`
    }
  }

  function getItemStyle(monthTS) {
    if (monthTS != lastMonthTimestamp) {
      return {
        borderWidth: 3,
      }
    } else {
      return {
        color: '#aaa',
        borderWidth: 3,
      }
    }
  }

  sortedMonthTimestamps.forEach(monthTS =>
    data.push({
      name: moment(monthTS).format('MMM'),
      value: valuesByMonthTs[monthTS],
      tooltip: getTooltip(monthTS),
      itemStyle: getItemStyle(monthTS),
    })
  )

  // console.log(xLabels)

  return {
    title: {
      text: `Glucometer Strip Usage`,
    },
    tooltip: {},
    grid: GRID,
    xAxis: [
      {
        gridIndex: 0,
        data: xLabels, // timestamps.map(timestamp => String(timestamp)),
        type: 'category',
        axisLine: { show: false },
        axisTick: {
          show: false,
          alignWithLabel: false,
        },
        splitLine: { show: false },
        axisLabel: {
          show: true,
        },
      },
    ],
    yAxis: [
      {
        gridIndex: 0,
        type: 'value',
        // splitNumber: 1,
        axisLine: { show: false },
        splitLine: { show: false },
        axisLabel: { show: true },
        min: 0,
      },
    ],
    series: [
      {
        data: data, //[150, 230, 224, 218, 135, 147, 260],
        type: 'line',
      },
    ],
  }
}
